import { assetUrl } from '@Shared/Helpers/Utilities';

export const REFERRAL_PROGRAM = [
    { title: __('Participants:'), desc: __('Your customers') },
    {
        title: __('Rewards:'),
        desc: __('Gift cards, discounts, store credits, cash, free service, swag'),
    },
    {
        title: __('How they share:'),
        desc: __('Usually happens via chat, social media, and word of mouth'),
    },
];
export const AFFILIATE_PROGRAM = [
    { title: __('Participants:'), desc: __('Affiliates and creators') },
    {
        title: __('Incentive types:'),
        desc: __('Cash rewards, both fixed amounts and commission amounts'),
    },
    {
        title: __('How they share:'),
        desc: __(
            'Usually happens via the affiliates website or blog posts, or via the creators social media posts'
        ),
    },
];

export const RP_TEMPLATES = [
    {
        header: __('Education'),
        icon: 'education',
    },
    {
        header: __('Healthclub'),
        icon: 'healthclub',
    },
    {
        header: __('SaaS'),
        icon: 'saas',
    },
    {
        header: __('Insurance'),
        icon: 'insurance',
    },
    {
        header: __('Marketing Agency'),
        icon: 'marketing-agency',
    },
];

export const TUTORIALS = [
    {
        id: '5YrSWSSE7Tw',
        title: __('Referral Factory explained in 30 seconds'),
        url: 'https://www.youtube-nocookie.com/embed/5YrSWSSE7Tw?autoplay=1&mute=0&rel=0',
    },
    {
        id: 'vniLhWjTh8Q',
        title: __('How to generate high qualify leads'),
        url: 'https://www.youtube-nocookie.com/embed/vniLhWjTh8Q?autoplay=1&mute=0&rel=0',
    },
    {
        id: 'Rls6nPxxxSc',
        title: __('How to build a referral program in 5 steps'),
        url: 'https://www.youtube-nocookie.com/embed/Rls6nPxxxSc?autoplay=1&mute=0&rel=0',
    },
    {
        id: 'hkTDW7596rk',
        title: __('Referral tracking (how it works)'),
        url: 'https://www.youtube-nocookie.com/embed/hkTDW7596rk?autoplay=1&mute=0&rel=0',
    },
];

export const DEMO_SIDEBAR = {
    builder: {
        label: __('Build'),
        value: 'builder',
    },
    promote: {
        label: __('Grow'),
        value: 'promote',
    },
    track: {
        label: __('Track'),
        value: 'track',
    },
    reward: {
        label: __('Reward'),
        value: 'reward',
    },
    integrate: {
        label: __('Integrate'),
        value: 'integrate',
    },
};

export const DEMO_PAGES = {
    builder: {
        title: __('Build your referral program in days not weeks'),
        features: [
            __('Referral program templates'),
            __('Page editors or upload HTML'),
            __('Flexible email notifications'),
            __('Generate unique links or QR codes'),
        ],
        imgName: 'builder',
        alt: 'no code referral program software - referral factory',
    },
    promote: {
        title: __('Start asking your customers and fans to refer'),
        features: [
            __('Easily track who referred who'),
            __('Send new referrals into your workflows'),
            __('Automate qualifying your referrals'),
            __('Post in our affiliate marketplace'),
        ],
        imgName: 'promote',
        alt: 'referral marketing program - referral factory',
    },
    track: {
        title: __('Easily track the source of each referral'),
        features: [
            __('Sign up pages, embed codes, link generator '),
            __('Pop ups and widgets to install on your website'),
            __('Send emails to promote your program'),
            __('Deep referral analytics and leaderboards'),
        ],
        imgName: 'track',
        alt: 'referral analytics - referral factory',
    },
    reward: {
        title: __('Issue rewards and incentives with ease'),
        features: [
            __('Cash through (PayPal, Stripe or Tremendous)'),
            __('200+ gift cards in multiple countries'),
            __('Custom rewards for swag, tokens and discounts'),
            __('Upload your own coupons to issue as rewards'),
        ],
        imgName: 'reward',
        alt: 'referral rewards - referral factory',
    },
    integrate: {
        title: __('Integrate easily with other tools and apps'),
        features: [
            __('Connect your CRM '),
            __('Connect your payment gateway'),
            __('API and webhook functionality'),
            __('Connect your 300+ apps via Zapier'),
        ],
        imgName: 'integrate',
        alt: 'referral automations - referral factory',
    },
};

export const DEMO_SECTION_DATA = [
    {
        label: __('Build a custom referral program'),
        value: 'builder',
        img: 'builder',
        text: __(
            "Use our drag and drop builder to build your own referral program, or upload your own HTML pages. You can also build pages where people can register to refer, and you can customize each user's referral link."
        ),
    },
    {
        label: __('Start asking for referrals'),
        value: 'promote',
        img: 'promote',
        text: __(
            'Get loads of tools to grow your referral program! Pop-ups, widgets, join links, email tools, QR codes, and more. You’ll also get automatically matched to 100 00+ niche affiliates and creators using AI.'
        ),
    },
    {
        label: __('Track your referral program'),
        value: 'track',
        img: 'track',
        text: __(
            'Tracking is automated out of the box with Referral Factory. You also get deep referral tracking software to understand how your referral program is performing. Easily see who referred who, who needs a reward, and how well your users are engaging.'
        ),
    },
    {
        label: __('Issue rewards and incentives'),
        value: 'reward',
        img: 'reward',
        text: __(
            'Reward with cash, vouchers, your own coupons, tokens, swag, discounts, credits and much more. Our referral software works with multiple currencies too. We offer a full suite of reward options, or the ability to make your own.'
        ),
    },
];

export const HOME_BLOG = {
    type: 'dark',
    className: 'mr-auto mt-8 flex-[2] !gap-6',
    position: 'start',
    icon: 'rocket',
    title: __('Why choose our referral software?'),
    desc: __(
        'We’ve been dubbed the fastest referral program software – because you can launch a fully custom referral program in just a few clicks! You can create a single sided referral program, double sided referral program, affiliate program, or ambassador program using our plug and play platform. :br Referral Factory is designed for startups, as well as established corporations with SOC2 compliance needs. We offer enterprise level security, a no-code way to track your referrals, integrations with many CRMs and Stripe, as well as 24/7 access to our team of referral marketing software experts.',
        {
            br: (
                <>
                    <br />
                    <br />
                </>
            ),
        }
    ),
    imgClassName: 'flex-1 max-w-[460px]',
    image: assetUrl('/assets/images/webp/web/unique/phones.webp'),
    imageLow: assetUrl('/assets/images/webp/web/unique/phones-low.webp'),
    alt: 'phones',
    link: 'customer.auth.register',
    linkText: 'Start free trial',
};

export const HOME_FAQ = [
    {
        title: __('How can I create a referral website?'),
        text: __(
            "To create a referral website, start by thinking how your referral program will work. Decide on the incentives, whether they’ll be single-sided, benefiting only the referrer, or double-sided, offering rewards to both the referrer and the new user. You'll also need to set clear terms and conditions to prevent fraud and ensure a fair system.:br Once you have the referral program structure, choose a platform for your website. If you want something customizable, WordPress with referral plugins could work to host your website. You can also opt for a no-code platform like Referral Factory if you want to fully customize your referral website concept, we have a full website builder that you can use to bring your referral website to life. :br After setting up your website, integrate referral tracking tools. Many customer referral program software solutions generate unique links for users, allowing you to monitor referrals and issue rewards. Platforms like Referral Factory, ReferralCandy, or Post Affiliate Pro can help manage the system seamlessly. :br The next step is designing an intuitive user experience. Make sure your referral process is easy to understand, with a clear call-to-action guiding users on how to refer others. A visually appealing landing page with a clear reward description can boost participation. See some :examples here. :br Once everything is set, promote your referral program through email marketing, social media, partnerships - or list it in the Referral Factory marketplace for free, be one of the :best :br Encourage existing users to spread the word by providing shareable referral links. And regularly analyze the data of these links so you know where to make improvements based on reach and conversions. ",
            {
                examples: (
                    <a
                        className='text-blue cursor-pointer underline hover:opacity-90'
                        rel='noopener noreferrer'
                        href={'https://referral-factory.com/referral-program-examples'}
                        target={'_blank'}
                    >
                        {__('referral program examples')}
                    </a>
                ),
                best: (
                    <a
                        className='text-blue cursor-pointer underline hover:opacity-90'
                        href={'https://referral-factory.com/best-referral-programs-to-earn'}
                        target={'_blank'}
                        rel='noopener noreferrer'
                    >
                        {__('best referral programs we showcase to affiliates.')}
                    </a>
                ),
                br: (
                    <>
                        <br />
                        <br />
                    </>
                ),
            }
        ),
    },
    {
        title: __('How does referral tracking integrate with my existing systems?'),
        text: __(
            'Referral tracking integrates with your existing systems by connecting referral software with your website, CRM, payment gateway, and analytics tools. This process ensures seamless tracking of referred users, automates reward distribution, and provides insights into each users referral performance. :br Most referral tracking tools integrate via API, webhooks, or integrations - if you use HubSpot, Stripe, Salesforce, Zoho, Intercom, Pipedrive, Service Titan, Zapier, Make or Monday.com - then you’re in luck. You can fully integrate with Referral Factory in just a few clicks.',
            {
                br: (
                    <>
                        <br />
                        <br />
                    </>
                ),
            }
        ),
    },
    {
        title: __('Is it difficult to set up and manage a client referral program?'),
        text: __(
            'The most challenging part is ensuring that customers stay engaged and motivated, but the initial setup requires attention too. You need to define the incentive structure, ensuring that both the ‘person invited’ and the ‘person referring’ have a strong motivation to participate. The program also needs clear rules to prevent abuse and ensure fair rewards. Integrating referral tracking software with your existing website, CRM, or e-commerce platform is usually straightforward if you choose software with built-in integrations. :br Once the program is live, automation takes care of most of the work. Referral tracking tools generate unique links for users, monitor sign-ups and conversions, and even distribute rewards automatically. Even though your referral marketing software will do all the heavy lifting for you - don’t forget that ongoing management is still necessary to analyze performance, optimize incentives, and engage users.',
            {
                br: (
                    <>
                        <br />
                        <br />
                    </>
                ),
            }
        ),
    },
    {
        title: __('How can I measure the ROI of my online referral program?'),
        text: __(
            'Measuring the ROI of your online referral program involves tracking key metrics that indicate the program’s effectiveness in driving new customers and revenue. Start by calculating the costs associated with running the program, including referral incentives, software subscriptions, marketing efforts, and any operational costs for managing referrals. :br Next, track referral-driven revenue by analyzing how many referred customers make purchases and their lifetime value (LTV). Compare the acquisition cost of referred customers to your traditional marketing channels to determine cost efficiency. :br To calculate ROI, use the formula: :br :formula :br For a more detailed analysis, monitor additional metrics like the conversion rate of referred users, the average order value of referrals compared to other customers, and the customer retention rate of referred clients. These insights help assess the quality of referred customers and whether they contribute to long-term business growth.',
            {
                br: (
                    <>
                        <br />
                        <br />
                    </>
                ),
                formula: (
                    <ul className={'list-disc pl-10'}>
                        <li>
                            {__(
                                'ROI (%) = [(Referral Revenue - Referral Costs) / Referral Costs] × 100'
                            )}
                        </li>
                    </ul>
                ),
            }
        ),
    },
    {
        title: __('How secure is a referral system?'),
        text: __(
            "Most referral software solutions include fraud prevention tools such as IP tracking, cookie-based tracking, and unique referral codes to prevent self-referrals, duplicate sign-ups, or bot-generated referrals. Some systems use two-factor authentication (2FA) or email verification to confirm real users before awarding incentives. :br Secure referral programs also integrate with payment processors like Stripe, PayPal, or bank transfers so that tracking a referral through to sale and purchase can be recorded by a trusted third party - this is what we offer at Referral Factory. :br As you can see there is a lot to consider when choosing a safe and secure referral tool - we suggest looking for a platform that's SOC2 certified and holds an ISO 27001 certificate. Referral Factory proudly holds both of these accolades to show our customers that we take the security of your referral program seriously.",
            {
                br: (
                    <>
                        <br />
                        <br />
                    </>
                ),
            }
        ),
    },
    {
        title: __('Can a referral app help prevent fraudulent referrals?'),
        text: __(
            'Yes, a referral app can help prevent fraudulent referrals by implementing automated fraud detection mechanisms. Most modern referral platforms come with built-in security features that track user behavior and identify suspicious activities. :br Common fraud prevention methods include IP tracking, which ensures that referrals aren’t coming from the same device or network, and cookie-based tracking, which prevents multiple sign-ups from the same browser. The ultimate way to ensure all users are real is to verify them - using an email confirmation, before their referral link is even issued. User verification is a bullet proof way to secure your referral program and keep your admin low.',
            {
                br: (
                    <>
                        <br />
                        <br />
                    </>
                ),
            }
        ),
    },
    {
        title: __('How much does referral software typically cost?'),
        text: __(
            'The cost of referral software varies depending on the platform, features, and business size. Pricing models generally fall into three categories: monthly subscriptions, commission-based fees, and one-time licenses. :br Most small businesses and startups can use basic software starting at $100 per month, which typically includes core features like referral tracking, automated rewards, and basic fraud prevention. :br For mid-sized businesses, plans range from $100-$400 per month, offering advanced customization,API access, integrations with CRM and email marketing tools, multi-step referral funnels, and better fraud detection. :br Enterprise-level software can cost $500-$1000+ per month, providing AI-driven features, advanced security, advanced analytics, and a dedicated account manager to be your hands on assistant.',
            {
                br: (
                    <>
                        <br />
                        <br />
                    </>
                ),
            }
        ),
    },
];
